/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const forgotPasswordPostRequestSchema = z.object({
  client: z.string(),
  client_secret: z.string(),
  email: z.string(),
});
